import React, {useEffect, useState} from "react";
import "../Form8/form8.css";
export const SiteBoundaries = ({ sites, onSitesChange }) => {
    const fieldRow = (label, value, onChange, placeholder) => (
        <div className="d-flex align-items-start mb-2 mx-0 px-0">
            <div style={{ width: "50px", padding: "0", margin: "0" }}>{label}:</div>
            <div className="flex-grow-1" style={{ padding: "0", margin: "0" }}>
                <textarea
                    className="form-control"
                    placeholder={placeholder}
                    value={value}
                    onChange={onChange}
                    style={{ margin: "0", padding: "0 4px" }}
                />
            </div>
        </div>
    );

    return (
        <div className="container-fluid px-0 mx-0">
            {fieldRow("पूर्व", sites.East, (e) => onSitesChange("East", e.target.value), "चौधरी")}
            {fieldRow("पश्चिम", sites.West, (e) => onSitesChange("West", e.target.value), "वानखडे")}
            {fieldRow("उत्तर", sites.North, (e) => onSitesChange("North", e.target.value), "चौधरी")}
            {fieldRow("दक्षिण", sites.South, (e) => onSitesChange("South", e.target.value), "चौधरी")}
        </div>
    );
};

export const Form8LastInfo=()=>{

    return <>
        <div className="mt-3 mb-3 ">
            <table className="w-100 no-border">
                <thead>
                <tr>
                    <th>दिनांक</th>
                    <th>ग्रामपंचायत शिक्का</th>
                    <th>ग्रा.वि.अ./ग्रामसेवक ग्रा.प.</th>
                </tr>
                </thead>
            </table>
        </div>
        <div className={"mt-3 mb-3"}>
            <strong>शेरा:</strong>
            <ul className={""}>
                <li>१) सदर नमुना ८ वरून खरेदी-विक्री,बँकासंबंधी किवा आर्थिक व्यवहार झाल्यास ग्रामपंचायत जबाबदार राहणार नाही.</li>
                <li>२) अतिक्रमण आणि सरकारी जागेची विक्री करण्यात येऊ नये , केल्यास घेणारा व देणारा जबाबदार राहतील.</li>
                <li>३) जागेच्या क्षेत्रफळाबाबत वाद उद्भवल्यास ग्रामपंचायत जबाबदार राहणार नाही,कारण नमुना ८ हा मालकी हक्काचा पुरावा नाही. त्या मधील मोजमापे तांत्रिक दृष्ट्या प्रमाणित नसून ग्रामपंचायत कर आकारणी साठी आहेत.</li>
                <li>४) न्यायालयीन उपगोगास किंवा ईतर शासकीय कार्यालयांसाठी वैयक्तिक लाभांकरिता ग्राह्य समजणे किंवा नाही हे त्या संबंधित विभागाची / कार्यालयाची जबाबदारी.</li>
            </ul>
        </div>
    </>
}

export const Section1 = React.memo(({ value, onChange }) => {
    return (
        <div>
            <table className="custom-table mb-2">
                <tbody>
                <tr>
                    <td>पंचायत आणी जिल्हा क्रमांक:</td>
                    <td>
                        <input
                            type="text"
                            value={value}
                            onChange={onChange}
                            className=""
                        />
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    );
});
export const Section2 = React.memo(({ grampanchayat, setGrampanchayat, panS, setPanS }) => {

    return (
        <div className="mt-3 row-2 section2">
            <table className="custom-table mb-2">
                <tbody>
                <tr>
                    <td>ग्राम पंचायत :</td>
                    <td className="size-1">
                        <input
                            value={grampanchayat}
                            onChange={(e) => setGrampanchayat(e.target.value)}
                        />
                    </td>
                    <td>पं. स. :</td>
                    <td className="size-1">
                        <input
                            value={panS}
                            onChange={(e) => setPanS(e.target.value)}
                        />
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    );
});
export const Section3 = React.memo(({ year1, setYear1, year2, setYear2 }) => {
    return (
        <div className="mt-3 row-2">
            <table className="custom-table mb-2">
                <tbody>
                <tr>
                    <td>प्लॉट धारकांच्या नवीन कर आकारणीचे प्रतीवेदन वर्ष:</td>
                    <td className="">
                        <input
                            value={year1}
                            onChange={(e) => setYear1(e.target.value)}
                        />
                    </td>
                    <td className="">
                        <input
                            value={year2}
                            onChange={(e) => setYear2(e.target.value)}
                        />
                    </td>
                    <td>पावतो</td>
                </tr>
                </tbody>
            </table>
            <p className={"p1"}>
                महाराष्ट्र ग्रा.पं. लेखा संहीता 2011 नमुना 8 नियम 32(1) साठी महाराष्ट्र शासन ग्रामविकास यांची अधिसूचना क्र.व्ही.पी.रा.म,२०१५ पत्र क्र. 140 म.रा.4(II) 31 डिसें. खंड) असेसमेंट लिस्ट ग्रामपंचायत नमुना 8 (असेसमेंट लिस्ट )
            </p>
        </div>
    );
});
export const Section4 = React.memo(({ isEdit=false,gramPanchayat, setGramPanchayat }) => {

    if(isEdit){
        return (
            <div className={"mt-3"}>
                <p>
                    महाराष्ट्र ग्रा.पं. लेखा संहीता 2011 नमुना 8 नियम 32(1) साठी महाराष्ट्र शासन ग्रामविकास यांची अधिसूचना क्र.व्ही.पी.रा.म,२०१५ पत्र क्र. 140 म.रा.4(II) 31 डिसें. खंड) असेसमेंट लिस्ट ग्रामपंचायत नमुना 8 (असेसमेंट लिस्ट )
                </p>
            </div>
        )
    }

    return (
        <div className="mt-3">
            <table className="custom-table mb-2">
                <tbody>
                <tr>
                    <td>ग्राम पंचायत :</td>
                    <td>
                        <input
                            value={gramPanchayat}
                            onChange={(e) => setGramPanchayat(e.target.value)}
                        />
                    </td>
                    <td className={"td1"}>
                        सन 2025-2026 ते 2028 ते 2029 सालासाठी करात पात्र असल्यास बांधकाम व खाली जागा यांच्या मालमत्तेची कर आकारणी
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    );
});



export  const Section5 = React.memo(({
                                 gramPanchayat, setGramPanchayat,
                                 oldPropertyNo, setOldPropertyNo,
                                 taluka, setTaluka,
                                 district, setDistrict,
                                 serialNo, setSerialNo,
                                 propertyNo, setPropertyNo,
                                 ownerName, setOwnerName,
                                 wifeName, setWifeName,
                                 occupantName, setOccupantName
                             }) => {
    return (
        <div className="mt-3 row-2">
            <table className="custom-table section5">
                <tbody>
                <tr>
                    <td>ग्राम/मोहल्ला</td>
                    <td>:</td>
                    <td className="size-1">
                        <input value={gramPanchayat} onChange={e => setGramPanchayat(e.target.value)} />
                    </td>
                    <td>जुना मालमत्ता क्र.</td>
                    <td className="size-1">
                        <input value={oldPropertyNo} onChange={e => setOldPropertyNo(e.target.value)} />
                    </td>
                </tr>
                <tr>
                    <td>तालुका</td>
                    <td>:</td>
                    <td className="size-1">
                        <input value={taluka} onChange={e => setTaluka(e.target.value)} />
                    </td>
                </tr>
                <tr>
                    <td>जिल्हा</td>
                    <td>:</td>
                    <td className="size-1">
                        <input value={district} onChange={e => setDistrict(e.target.value)} />
                    </td>
                </tr>
                <tr>
                    <td>1. अनु क्रमांक <span className="text-danger">*</span></td>
                    <td>:</td>
                    <td className="size-1">
                        <input value={serialNo} onChange={e => setSerialNo(e.target.value)} />
                    </td>
                </tr>
                <tr>
                    <td>2. मालमत्ता क्रमांक<span className="text-danger">*</span></td>
                    <td>:</td>
                    <td className="size-1">
                        <input value={propertyNo} onChange={e => setPropertyNo(e.target.value)} />
                    </td>
                </tr>
                <tr>
                    <td>3. घरमालकाचे नाव</td>
                    <td>:</td>
                    <td className="size-1">
                        <input value={ownerName} onChange={e => setOwnerName(e.target.value)} />
                    </td>
                </tr>
                <tr>
                    <td>4. पत्नीचे नाव</td>
                    <td>:</td>
                    <td className="size-1">
                        <input value={wifeName} onChange={e => setWifeName(e.target.value)} />
                    </td>
                </tr>
                <tr>
                    <td>5. भोगवटदाराचे नाव</td>
                    <td>:</td>
                    <td className="size-1">
                        <input value={occupantName} onChange={e => setOccupantName(e.target.value)} />
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    );
});


export const Thead = React.memo(() => {
    return (
        <thead>
        <tr>
            <th>जागेची चतु:सिमा</th>
            <th>सिटी सर्व्हे न.</th>
            <th>एकूण जागेचे क्षेत्रफळ (चौ.फूट)</th>
            <th>खाली जागेचे क्षेत्रफळ (चौ.फूट)</th>
            <th>मालमत्तेचे वर्णन</th>
            <th>इमारत बांधकामाचे क्षेत्रफळ (चौ.फूट)</th>
            <th>इमारत बांधकामाचे वर्ष व वयोमान</th>
            <th>रेडीरेकनर दर प्रती (चो. मी.)</th>
            <th>घसारा दर वयानुसार</th>
            <th>भांडवली मूल्य इमारतीचे व जमीनीचे</th>
            <th>इमारतीचा वापर १ त्यानुसार भारांक</th>
            <th>कराचा दर (पैसे)</th>
            <th>आकारणी केलेल्या कराची रक्कम</th>
            <th>एकूण कर रक्कम</th>
            <th>अपील फेरफार नंतरचे कर</th>
        </tr>
        </thead>
    );
});


export const ColumnNumber = React.memo(() => {
    return (
        <tr className={"custom-row td"}>
            <td>6</td>
            <td>7</td>
            <td>8</td>
            <td>11</td>
            <td>9</td>
            <td>10</td>
            <td>12</td>
            <td>
                <div className="site-table-container">
                    <div className="site-table-row">
                        <div className="site-table-cell site-border-end">13</div>
                        <div className="site-table-cell">14</div>
                    </div>
                </div>
            </td>
            <td>15</td>
            <td>16</td>
            <td>17</td>
            <td>18</td>
            <td>19</td>
            <td>20</td>
            <td>21</td>
        </tr>
    );
});


export const LableColumn = React.memo(({ count, setCount,Remove,Add}) => {


    return (
        <tr className={"custom-row td"}>
            {/* 6 */}
            <td>दिशा</td>

            {/* 7 */}
            <td></td>

            {/* 8 */}
            <td style={{"overflow": "hidden"}}>

                <div className="site-table-container">
                    <div className="site-table-row">
                        <div className="site-table-cell site-border-end">पु.प.</div>
                        <div className="site-table-cell">उ.द.</div>
                    </div>
                </div>

            </td>

            {/* 11 */}
            <td></td>

            {/* 9 */}
            <td>
                <div>मालमत्ता</div>
                <div className="site-table-container hide-btn">
                    <div className="site-table-row">
                        <div className="site-table-cell site-border-end">
                            <button onClick={() => Add()}>+</button>
                        </div>
                        <div className="site-table-cell">
                            <button onClick={() => Remove()}>-</button>
                        </div>
                    </div>
                </div>
            </td>

            {/* 10 */}
            <td>
                <div className="site-table-container">
                    <div className="site-table-row">
                        <div className="site-table-cell site-border-end">पु.प.</div>
                        <div className="site-table-cell">उ.द.</div>
                    </div>
                </div>
            </td>

            {/* 12 */}
            <td></td>

            {/* 13 + 14 */}
            <td>
                <div className="site-table-container">
                    <div className="site-table-row">
                        <div className="site-table-cell site-border-end">इमारत</div>
                        <div className="site-table-cell">जमीन</div>
                    </div>
                </div>

            </td>

            {/* 15 */}
            <td></td>

            {/* 16 */}
            <td>
                <div className="site-table-container">
                    <div className="site-table-row">
                        <div className="site-table-cell site-border-end">इमारत</div>
                        <div className="site-table-cell">जमीन</div>
                    </div>
                </div>
            </td>

            {/* 17 */}
            <td></td>

            {/* 18 */}
            <td>
                <div className="site-table-container">
                    <div className="site-table-row">
                        <div className="site-table-cell site-border-end">इमारत</div>
                        <div className="site-table-cell">जमीन</div>
                    </div>
                </div>
            </td>

            {/* 19 */}
            <td>
                <div className="site-table-container ">
                    <div className="site-table-row six-box-div">
                        <div className="site-table-cell site-border-end">
                            गृहकर
                        </div>
                        <div className="site-table-cell site-border-end">
                            भूमीकर
                        </div>
                        <div className="site-table-cell site-border-end">
                            विजकर
                        </div>
                        <div className="site-table-cell site-border-end">
                            आरोग्यकर
                        </div>
                        <div className="site-table-cell site-border-end">
                            सा.पाणीकरकर
                        </div>
                        <div className="site-table-cell">वि.पाणीकर</div>
                    </div>
                </div>
            </td>

            {/* 20 */}
            <td></td>

            {/* 21 */}
            <td></td>
        </tr>
    );
});

export function Row1({
                         sites,
                         handleRemainChange,
                  handleSiteChange,
                  handleAreaChange,
                  total_area_east_west1,
                  total_area_north_south1,
                  total_area_east_west2,
                  total_area_north_south2,
                  remain_area,
                  remain_area1,
    //=================col-7=====
                    valueCol7,
                    onChangeCol7,
                   years,
                   onChangeAddExtra,index,
                   extendRow,
                   bhumikar,onChangeBox,box,col20,col21,setCol21,
                    isPrint=false
              }) {




    function AddExtra(key,data,typeKey="") {
        onChangeAddExtra({
            key:key,
            data:data,
            type:typeKey
        },index);
    }

    return (
        <tr className="custom-row td">
            {/*=========6=========*/}
            <td colSpan={1} rowSpan={4}>
                <SiteBoundaries sites={sites} onSitesChange={handleSiteChange} />
            </td>
            {/*=========7=========*/}
            <td width={40}>
                <textarea style={{"width":"40px"}} value={valueCol7} onChange={(e)=>onChangeCol7(e.target.value)} />
            </td>
            {/*=========8=========*/}
            <td>
                <EastWestNorthSouthInputs
                    ew1={total_area_east_west1}
                    ew2={total_area_east_west2}
                    ns1={total_area_north_south1}
                    ns2={total_area_north_south2}
                    onChange={handleAreaChange}
                />
            </td>
            {/*=========11=========*/}
            <td className="size-2">
                <RemainAreaInputs
                    //isReadOnly={true}
                    isDisable={true}
                    value1={remain_area}
                    value2={remain_area1}
                    onChange={handleRemainChange}
                />
            </td>
            {/*=========9=========*/}
            <td>
                {
                    isPrint?
                        extendRow.Col9:
                        <select value={extendRow.Col9} onChange={(e)=>{AddExtra('Col9',e.target.value)}}>
                            <option value="झोपडी किंवा मातीचे घर">झोपडी किंवा मातीचे घर</option>
                            <option value="दगडी विटा मातीचे घर">दगडी विटा मातीचे घर</option>
                            <option value="दगडीविटा चुना/सिमेंटचे घर">दगडीविटा चुना/सिमेंटचे घर</option>
                            <option value="आर.सी.सी स्लबचे घर">आर.सी.सी स्लबचे घर</option>
                            <option value="खाली जागा">खाली जागा</option>
                            <option value="पहिला मजला">पहिला मजला</option>
                            <option value="दुसरा मजला ">दुसरा मजला </option>
                            <option value="तिसरा  मजला ">तिसरा  मजला </option>
                        </select>
                }
            </td>
            {/*=============10========*/}
            <td>
                <DoubleInputTable value1={extendRow.Col10.East_West}
                                  value2={extendRow.Col10.North_South}
                                  onChange={(key,value)=>{

                                      if(key==="East_West"){
                                          AddExtra('Col10',{East_West:value,North_South:extendRow.Col10.North_South},key);
                                      }else
                                      {
                                          AddExtra('Col10',{East_West:extendRow.Col10.East_West,North_South:value},key);
                                      }

                                  }}
                />
            </td>
            {/*=============12========*/}
            <td>
                {
                    isPrint?
                        extendRow.Year:
                        <YearSelect value={extendRow.Year} years={years} onChange={(e)=>{
                            AddExtra('Year',e.target.value)
                        }} />
                }

            </td>
            {/*=============13 14========*/}
            <td>
                <DoubleInputTable value1={extendRow.Col13_Col14.Building}
                                  value2={extendRow.Col13_Col14.Land}
                                  onChange={(key,value)=>{
                                      if(key==="East_West"){
                                          AddExtra('Col13_Col14',{Building:value,Land:extendRow.Col13_Col14.Land},key);
                                      }else
                                      {
                                          AddExtra('Col13_Col14',{Building:extendRow.Col13_Col14.Building,Land:value},key);
                                      }
                                  }}
                />
            </td>
            {/*=============15========*/}
            <td>
                <input value={extendRow.Col15} className={"col15-size"}  onChange={(e) => {AddExtra('Col15',e.target.value)}} />
            </td>
            {/*=============16========*/}
            <td>
                <DoubleInputTable value1={parseFloat(extendRow.Col16.Building).toFixed(2)}
                                  value2={parseFloat(extendRow.Col16.Land).toFixed(2)}
                               //   isReadOnly={true}
                                  isDisable={true}
                                  onChange={(key,value)=>{
                                     // console.log(`566 key=${key} value=${value}`)
                                  }}
                />
            </td>
            {/*=============17========*/}
            <td>
                <UseTypeSelect value={extendRow.Col17} onChange={(value)=>{AddExtra('Col17',value)}} />
            </td>
            {/*=============18========*/}
            <td>
                <DoubleInputTable value1={extendRow.Col18.Building}
                                  value2={extendRow.Col18.Land}
                                  onChange={(key,value)=>{
                                      if(key==="East_West"){
                                          AddExtra('Col18',{Building:value,Land:extendRow.Col18.Land},key);
                                      }else
                                      {
                                          AddExtra('Col18',{Building:extendRow.Col18.Building,Land:value},key);
                                      }
                                  }} />
            </td>
            {/*=============19========*/}
            <td>
                <SixInputRow box1={extendRow.Col19_Gruhakar}
                             box2={bhumikar}
                             box3={box.box3}
                             box4={box.box4}
                             box5={box.box5}
                             box6={box.box6}
                             onChange={(key,value)=>{onChangeBox(key,value,index);}} />
            </td>
            {/*=============20========*/}
            <td className="size-4">
                <input readOnly={true} disabled={true} value={col20} onChange={() => {}} />
            </td>
            {/*=============21========*/}
            <td className="size-4">
                <input value={col21} onChange={(e) => {setCol21(e.target.value)}} />
            </td>
        </tr>
    );
}


//==================Row 1=========
const EastWestNorthSouthInputs = React.memo(function EastWestNorthSouthInputs({ ew1, ew2, ns1, ns2, onChange }) {

    return <>
        <div className="site-table-container">
            <div className="site-table-row input-size1">
                <div className="site-table-cell site-border-end">
                    <input
                        onChange={(e) => onChange('ew1', e.target.value)}
                        placeholder={0.0}
                        value={ew1} />
                </div>
                <div className="site-table-cell">
                    <input onChange={(e) => onChange('ns1', e.target.value)}
                           placeholder={0.0}
                           value={ns1} />
                </div>
            </div>
        </div>
        <div className="site-table-container">
            <div className="site-table-row input-size1">
                <div className="site-table-cell site-border-end">
                    <input onChange={(e) => onChange('ew2', e.target.value)}
                           placeholder={0.0}
                           value={ew2} />
                </div>
                <div className="site-table-cell">
                    <input onChange={(e) => onChange('ns2', e.target.value)}
                           placeholder={0.0}
                           value={ns2} />
                </div>
            </div>
        </div>

    </>
});

const RemainAreaInputs = React.memo(function RemainAreaInputs({ value1, value2,isReadOnly=false,isDisable=false ,onChange }) {
    return (
        <>
            <div className="site-table-container">
                <div className="site-table-row">
                    <div className="site-table-cell">
                        <input
                            readOnly={isReadOnly}
                            disabled={isDisable}
                            onChange={(e) => onChange('remain1', e.target.value)}
                            value={value1}
                            placeholder={0.0}
                        />
                    </div>
                </div>
            </div>
            <div className="site-table-container">
                <div className="site-table-row">
                    <div className="site-table-cell">
                        <input
                            readOnly={isReadOnly}
                            disabled={isDisable}
                            placeholder={0.0}
                            onChange={(e) => onChange('remain2', e.target.value)}
                            value={value2}
                        />
                    </div>
                </div>
            </div>
        </>
    );
});
const DoubleInputTable =React.memo(function DoubleInputTable({ value1 = 0, value2 = 0,isReadOnly=false,isDisable=false, onChange = () => {} }) {

    return <>
        <div className="site-table-container">
            <div className="site-table-row input-size1">
                <div className="site-table-cell site-border-end">
                    <input
                        placeholder={0}
                        readOnly={isReadOnly}
                        disabled={isDisable}
                        value={value1}
                        //value={parseInt(value1).toFixed(2)}
                        onChange={(e) => onChange('East_West', e.target.value)}
                    />
                </div>
                <div className="site-table-cell">
                    <input
                        placeholder={0}
                        readOnly={isReadOnly}
                        disabled={isDisable}
                        value={value2}
                        //value={parseInt(value2).toFixed(2)}
                        onChange={(e) => onChange('North_South', e.target.value)}
                    />
                </div>
            </div>
        </div>
    </>
});

const YearSelect = React.memo(function YearSelect({ years, value, onChange }) {
    return (
        <select value={value} onChange={onChange}>
            <option value="">Select Year</option>
            {years.map((year) => (
                <option key={year} value={year}>
                    {year}
                </option>
            ))}
        </select>
    );
});

const UseTypeSelect=React.memo(function UseTypeSelect({value="",onChange}) {
        return (
            <select value={value} onChange={(e)=>{onChange(e.target.value)}}>
                <option value="निवासी">निवासी</option>
                <option value="व्यावसायिक">व्यावसायिक</option>
                <option value="औधोगीक">औधोगीक</option>
            </select>
        );
    });
const SixInputRow=React.memo(function SixInputRow({box1=0,box2=0,box3=0,box4=0,box5=0,box6=0,onChange}) {

    return <>
        <div className="site-table-container six-box">
            <div className="site-table-row">
                <div className="site-table-cell site-border-end">
                    <input value={parseFloat(box1).toFixed(3)} readOnly={true} disabled={true} />
                </div>
                <div className="site-table-cell site-border-end">
                    <input value={parseFloat(box2).toFixed(3)} readOnly={true} disabled={true} />
                </div>
                <div className="site-table-cell site-border-end">
                    <input value={box3} onChange={(e) => {onChange('box3',e.target.value)}} />
                </div>
                <div className="site-table-cell site-border-end">
                    <input value={box4} onChange={(e) => {onChange('box4',e.target.value)}} />
                </div>
                <div className="site-table-cell site-border-end">
                    <input value={box5} onChange={(e) => {onChange('box5',e.target.value)}}  />
                </div>
                <div className="site-table-cell">
                    <input value={box6} onChange={(e) => {onChange('box6',e.target.value)}}  />
                </div>
            </div>
        </div>

    </>

    });

//===========Row 2========
export const Row2 = React.memo(({ total_sq_ft = "",openSpaceSq_Ft,grandTotal,extendRow }) => {
    return (
        <tr className="custom-row td">
            {/*------7----------*/}
            <td rowSpan={3}></td>

            {/*------8----------*/}
            <td>
                <table className="w-100">
                    <tbody>
                    <tr className="td-size">
                        <td className="size-2">Sq.Ft.</td>
                        <td className="size-2">
                            <input
                                readOnly={true} disabled={true}
                                value={total_sq_ft}
                            />
                        </td>
                    </tr>
                    </tbody>
                </table>
            </td>

            {/*------11----------*/}
            <td className="size-2">
                एकूण खाली जागा
                <br />
                <input value={openSpaceSq_Ft}
                       readOnly={true}
                       disabled={true} />
            </td>

            {/*------9----------*/}
            <td rowSpan={3}></td>

            {/*------10----------*/}
            <td>
                <table className="w-100">
                    <tbody>
                    <tr>
                        <td>Sq.Ft.</td>
                    </tr>
                    <tr className="td-size">
                        <td className="size-2">
                            <input value={extendRow.Sq_Ft}  readOnly={true} disabled={true}  />
                        </td>
                    </tr>
                    </tbody>
                </table>
            </td>

            {/*------12 to 18----------*/}
            <td colSpan={5}></td>

            {/*------19----------*/}
            <td colSpan={3}>
                <table className="w-100">
                    <tbody>
                    <tr>
                        <td colSpan={7}>
                            अपिलाचे निकाल आणि त्यानंतर केलेले फेरफार
                        </td>
                    </tr>
                    <tr>
                        <td className="size-4">
                            गृहकर Grand Total
                            <br />
                            <input value={grandTotal}
                                   //readOnly={true}
                                   disabled={true} />
                        </td>
                        <td className="size-4">गृह</td>
                        <td className="size-4">विज</td>
                        <td className="size-4">आरोग्य</td>
                        <td className="size-4">सा.पा.</td>
                        <td className="size-4">वि. पाणी</td>
                        <td className="size-4">एकूण</td>
                    </tr>
                    </tbody>
                </table>
            </td>

            {/*------20----------*/}
            <td ></td>
        </tr>
    );
});

//==========Row 3=======
export const Row3 = React.memo(({ total_sq_mt = "",openSpaceSq_Mt,extendRow }) => {
    return (
        <tr className="custom-row td">
            {/*------6----------*/}
            {/*------7----------*/}

            {/*------8----------*/}
            <td>
                <table className="w-100">
                    <tbody>
                    <tr className="td-size">
                        {/*-------- 8 Sq.Mt. --------*/}
                        <td className="size-2">Sq.Mt.</td>
                        <td className="size-2">
                            <input
                                //readOnly={true}
                                disabled={true}
                                value={total_sq_mt}
                            />
                        </td>
                    </tr>
                    </tbody>
                </table>
            </td>

            {/*------11----------*/}
            <td className="size-2">
                <input value={parseFloat(openSpaceSq_Mt).toFixed(2)}
                      // readOnly={true}
                       disabled={true}  />
            </td>

            {/*------9----------*/}


            {/*------10----------*/}
            <td>
                <table className="w-100">
                    <tbody>
                    <tr>
                        <td>Sq.Mt.</td>
                    </tr>
                    <tr className="td-size">
                        <td className="size-2">
                            <input value={extendRow.Sq_Mt}  disabled={true} />
                        </td>
                    </tr>
                    </tbody>
                </table>
            </td>

            {/*------12 to 18----------*/}
            <td colSpan={9}></td>

            {/*------19----------*/}

            {/*------20----------*/}

            {/*------21----------*/}
        </tr>
    );
});

//=======Row 4======
export const Row4 = React.memo(() => {
    return (
        <tr className="custom-row td">
            {/*------6----------*/}
            {/*------7----------*/}

            {/*------8----------*/}
            <td colSpan={2}></td>

            {/*------11----------*/}

            {/*------9----------*/}


            {/*------10----------*/}
            <td></td>

            {/*------12----------*/}
            <td></td>

            {/*------13----------*/}
            {/*------14----------*/}
            <td></td>

            {/*------15----------*/}
            <td></td>

            {/*------16----------*/}
            <td></td>

            {/*------17----------*/}
            <td></td>

            {/*------18----------*/}
            <td></td>

            {/*------19----------*/}
            <td colSpan={3}></td>

            {/*------20----------*/}
            {/*<td></td>*/}

            {/*------21----------*/}
            {/*<td></td>*/}
        </tr>
    );
});


//======Tip

export const Tip = React.memo(({tip,setTip,adharcard,setAdharcard,mobile,setMobile}) => {
    const [height,setHeight]=useState();
    return (
        <>
            <tr className="custom-row td">
                <td colSpan={11}></td>
                <td colSpan={4}>
                    <table className="w-100 tip">
                        <tbody>
                        <tr>
                            <td className="size-4 tip-col">टीप :- </td>
                            <td  colSpan={6}>
                                {/*<input type={"textarea"} className="w-100" value={tip} onChange={(e)=>setTip(e.target.value)} />*/}
                                <textarea
                                    className="w-100"
                                    value={tip}
                                    onChange={(e) => setTip(e.target.value)}
                                    rows={7} // You can change the number of visible rows
                                />

                            </td>
                        </tr>
                        </tbody>
                    </table>
                </td>
            </tr>
            <tr className="custom-row td mobile">
                <td colSpan={11}></td>
                <td colSpan={4}>आधार क्रमांक
                    <input value={adharcard} onChange={(e)=>setAdharcard(e.target.value)} className={""}/>
                    मोबाईल
                    <input value={mobile} onChange={(e)=>setMobile(e.target.value)} />
                </td>
            </tr>
        </>
    );
});


export const AddExtraField=React.memo(({onChangeAddExtra,index, extendRow})=>{
    const currentYear = new Date().getFullYear();
    const years = [];

    for (let year = 1950; year <= currentYear; year++) {
        years.push(year);
    }

    function AddExtra(key,data,typeKey="") {
        onChangeAddExtra({
            key:key,
            data:data,
            type:typeKey
        },index);
    }

    // useEffect(()=>{
    //     console.log('========')
    //    console.log(extendRow);
    //     console.log('========')
    // },[])

    return (
        <>
            {/*----------------Row1---------------*/}
            <tr className="custom-row td">
                {/*------6----------*/}
                <td colSpan={4} rowSpan={3}></td>
                {/*------7----------*/}
                {/*------8----------*/}
                {/*------11----------*/}
                {/*------9----------*/}
                <td>
                    <select value={extendRow.Col9} onChange={(e)=>{AddExtra('Col9',e.target.value)}}>
                        <option value="झोपडी किंवा मातीचे घर">झोपडी किंवा मातीचे घर</option>
                        <option value="दगडी विटा मातीचे घर">दगडी विटा मातीचे घर</option>
                        <option value="दगडीविटा चुना/सिमेंटचे घर">दगडीविटा चुना/सिमेंटचे घर</option>
                        <option value="आर.सी.सी स्लबचे घर">आर.सी.सी स्लबचे घर</option>
                        <option value="खाली जागा">खाली जागा</option>
                        <option value="पहिला मजला">पहिला मजला</option>
                        <option value="दुसरा मजला ">दुसरा मजला </option>
                        <option value="तिसरा  मजला ">तिसरा  मजला </option>
                    </select>
                </td>
                {/*------10----------*/}
                <td>
                    <DoubleInputTable value1={extendRow.Col10.East_West}
                                      value2={extendRow.Col10.North_South}
                                      onChange={(key,value)=>{

                                          if(key==="East_West"){
                                              AddExtra('Col10',{East_West:value,North_South:extendRow.Col10.North_South},key);
                                          }else
                                          {
                                              AddExtra('Col10',{East_West:extendRow.Col10.East_West,North_South:value},key);
                                          }

                                      }}
                    />
                </td>
                {/*------12----------*/}
                <td>
                    <YearSelect value={extendRow.Year} years={years} onChange={(e)=>{
                        AddExtra('Year',e.target.value)
                    }} />
                </td>
                {/*------13 & 14----------*/}
                <td>
                    <DoubleInputTable value1={extendRow.Col13_Col14.Building}
                                      value2={extendRow.Col13_Col14.Land}
                                      onChange={(key,value)=>{
                                          if(key==="East_West"){
                                              AddExtra('Col13_Col14',{Building:value,Land:extendRow.Col13_Col14.Land},key);
                                          }else
                                          {
                                              AddExtra('Col13_Col14',{Building:extendRow.Col13_Col14.Building,Land:value},key);
                                          }
                                      }}
                    />
                </td>
                {/*------15----------*/}
                <td>
                    <input className={"col15-size"}  onChange={(e) => {AddExtra('Col15',e.target.value)}} />
                </td>
                {/*------16----------*/}
                <td>
                    <DoubleInputTable value1={extendRow.Col16.Building}
                                      value2={extendRow.Col16.Land}
                        //   isReadOnly={true}
                                      isDisable={true}
                                      onChange={(key,value)=>{
                                          // console.log(`566 key=${key} value=${value}`)
                                      }}
                    />
                </td>
                {/*------17----------*/}
                <td>
                    <UseTypeSelect value={extendRow.Col17} onChange={(value)=>{AddExtra('Col17',value)}} />
                </td>
                {/*------18----------*/}
                <td>
                    <DoubleInputTable value1={extendRow.Col18.Building}
                                      value2={extendRow.Col18.Land}
                                      onChange={(key,value)=>{
                                          if(key==="East_West"){
                                              AddExtra('Col18',{Building:value,Land:extendRow.Col18.Land},key);
                                          }else
                                          {
                                              AddExtra('Col18',{Building:extendRow.Col18.Building,Land:value},key);
                                          }
                                      }} />
                </td>
                {/*------19, 20, 21----------*/}
                <td colSpan={3} className="text-start">
                    <input disabled={true} value={extendRow.Col19_Gruhakar} />
                </td>
            </tr>

            {/*----------------Row2---------------*/}
            <tr className="custom-row td">
                {/*------6----------*/}
                {/*<td></td>*/}
                {/*------7----------*/}
                {/*<td></td>*/}
                {/*------8----------*/}
                {/*<td></td>*/}
                {/*------11----------*/}
                {/*<td className="size-2"></td>*/}
                {/*------9----------*/}
                <td rowSpan={2}></td>
                {/*------10----------*/}
                <td>
                    <table className="w-100">
                        <tbody>
                        <tr>
                            <td>Sq.Ft.</td>
                        </tr>
                        <tr className="td-size">
                            <td className="size-2">
                                <input value={extendRow.Sq_Ft}  readOnly={true} disabled={true}  />
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </td>
                {/*------12----------*/}
                <td colSpan={9} rowSpan={2}></td>
                {/*------13 & 14----------*/}
                {/*<td></td>*/}
                {/*------15----------*/}
                {/*<td></td>*/}
                {/*------16----------*/}
                {/*<td></td>*/}
                {/*------17----------*/}
                {/*<td></td>*/}
                {/*------18----------*/}
                {/*<td></td>*/}
                {/*------19, 20, 21----------*/}
                {/*<td colSpan={3}></td>*/}
            </tr>

            {/*----------------Row3---------------*/}
            <tr className="custom-row td">
                {/*------6----------*/}
                {/*<td></td>*/}
                {/*------7----------*/}
                {/*<td></td>*/}
                {/*------8----------*/}
                {/*<td></td>*/}
                {/*------11----------*/}
                {/*<td className="size-2"></td>*/}
                {/*------9----------*/}
                {/*<td></td>*/}
                {/*------10----------*/}
                <td>
                    <table className="w-100">
                        <tbody>
                        <tr>
                            <td>Sq.Mt.</td>
                        </tr>
                        <tr className="td-size">
                            <td className="size-2">
                                <input value={extendRow.Sq_Mt}  disabled={true} />
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </td>
                {/*------12----------*/}
                {/*<td></td>*/}
                {/*------13 & 14----------*/}
                {/*<td></td>*/}
                {/*------15----------*/}
                {/*<td></td>*/}
                {/*------16----------*/}
                {/*<td></td>*/}
                {/*------17----------*/}
                {/*<td></td>*/}
                {/*------18----------*/}
                {/*<td></td>*/}
                {/*------19, 20, 21----------*/}
                {/*<td colSpan={3}></td>*/}
            </tr>
        </>
    );
})







